import { Project } from "../Types/Project";

type Props = {
  propList: Project[];
  title: string;
};

const ProjectsComponent = ({ propList, title }: Props) => {
  return (
    <section className="cv-section">
      <div className="cv-card space-y-5">
        <h2 className="cv-heading">{title}</h2>

        <div className="grid gap-4 md:grid-cols-2">
          {propList.map((project, index) => (
            <article
              key={index}
              className="border border-brand-soft/60 bg-brand-soft/10 p-4 shadow-sm space-y-3"
            >
              <div className="flex flex-wrap items-baseline justify-between gap-3">
                <h3 className="cv-subheading">{project.title}</h3>
                <span className="cv-meta">{project.year}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {project.keywords.map((keyword, idx) => (
                  <span key={idx} className="cv-tag">{keyword}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsComponent;
